<template>
  <div class="app-container">
    <div class="availability-banner" role="status" aria-live="polite">
      <span class="ab-text">
        本日 <strong>{{ nowLabel }}</strong><br class="sp-br" />
        最短で案内可能な業者はこちら！
      </span>
    </div>

    <div class="titled-box-container-rank1">
      <h2 class="titled-box-header">
        <br />
        <span><img src="../../assets/rank1/badge.png" alt=""></span>
        給湯器駆けつけ隊
      </h2>
      <div class="titled-box-content">
        <RatingBarRank1 />
        <div class="vendor-img">
          <img src="../../assets/rank-table/vendor-1.png" alt="" />
        </div>
        <InfoGridRank1 />
        <ButtonRank101 />
        <RecommendPointRank1 />
        <ReviewsContentRank1 />
        <ButtonRank1 />
      </div>
    </div>

    <div class="titled-box-container-rank2">
      <h2 class="titled-box-header">
        <br />
        <span><img src="../../assets/rank2/badge.png" alt=""></span>
        お湯が出ない.com
      </h2>
      <div class="titled-box-content">
        <RatingBarRank2 />
        <div class="vendor-img">
          <img src="../../assets/rank-table/vendor-4-1.png" alt="" />
        </div>
        <InfoGridRank2 />
        <RecommendPointRank2 />
        <ReviewsContentRank2 />
        <br>
        <ButtonRank2 />
      </div>
    </div>
    <div class="titled-box-container-rank3">
      <h2 class="titled-box-header">
        <br />
        <span><img src="../../assets/rank3/badge.png" alt=""></span>
        チカラもち
      </h2>
      <div class="titled-box-content">
        <RatingBarRank3 />
        <div class="vendor-img">
          <img src="../../assets/rank-table/vendor-6.png" alt="" />
        </div>
        <InfoGridRank3 />
        <RecommendPointRank3 />
        <ReviewsContentRank3 />
        <br>
        <ButtonRank3 />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

import InfoGridRank1 from './InfoGridRank1.vue';
import InfoGridRank2 from './InfoGridRank2.vue';
import InfoGridRank3 from './InfoGridRank3.vue';
import RatingBarRank1 from './RatingBarRank1.vue';
import RatingBarRank2 from './RatingBarRank2.vue';
import RatingBarRank3 from './RatingBarRank3.vue';
import RecommendPointRank1 from './RecommendPointRank1.vue';
import RecommendPointRank2 from './RecommendPointRank2.vue';
import RecommendPointRank3 from './RecommendPointRank3.vue';
import ReviewsContentRank1 from './ReviewsContentRank1.vue';
// import ReviewsContentRank2 from './ReviewsContentRank2.vue';
// import ReviewsContentRank3 from './ReviewsContentRank3.vue';
import ButtonRank1 from './ButtonRank1.vue';
import ButtonRank101 from './ButtonRank101.vue';
import ButtonRank2 from './ButtonRank2.vue';
import ButtonRank3 from './ButtonRank3.vue';

const nowLabel = ref('');
let timerId;

const pad = (n) => String(n).padStart(2, '0');
const updateNow = () => {
  const d = new Date();
  nowLabel.value = `${d.getMonth() + 1}月${d.getDate()}日${pad(d.getHours())}時${pad(d.getMinutes())}分`;
};

onMounted(() => {
  updateNow();
  timerId = setInterval(updateNow, 1000);
});
onBeforeUnmount(() => {
  if (timerId) clearInterval(timerId);
});
</script>

<style scoped>
.app-container {
  background: #eef5ff;
  padding-bottom: 30px;
}

.availability-banner {
  position: relative;
  margin: 14px 25px 0;
  padding: 15px;
  background: #d9534f;
  color: #fff;
  font-weight: 800;
  text-align: center;
  margin-top: 0;
  border-radius: 30px;
}

.titled-box-header img {
  width: 65px;
}

.availability-banner::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -16px;
  width: 0;
  height: 0;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #d9534f;
  filter: drop-shadow(0 2px 0 rgba(0, 0, 0, .08));
  animation: abArrowFloat 1.4s ease-in-out infinite;
}

@keyframes abArrowFloat {
  0%   { bottom: -16px; }
  50%  { bottom: -10px; }
  100% { bottom: -16px; }
}

@media (prefers-reduced-motion: reduce) {
  .availability-banner::after {
    animation: none;
  }
}

.ab-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  translate: 0 -50%;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: #fff;
  color: #ff7a00;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 900;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.ab-text {
  display: inline-block;
  line-height: 1.35;
  font-size: 1rem;
}

.ab-text strong {
  font-size: 1.15rem;
  text-decoration: underline;
  text-underline-offset: 3px;
  color: #f3d67f;
}

.titled-box-container-rank1,
.titled-box-container-rank2,
.titled-box-container-rank3 {
  margin-top: 0;
  overflow: hidden;
}

.titled-box-container-rank1 .titled-box-header,
.titled-box-container-rank2 .titled-box-header,
.titled-box-container-rank3 .titled-box-header {
  background-color: #3f51b5;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 900;
  font-size: 1.5rem;
  margin-right: 10px;
  margin-left: 10px;
  border-radius: 10px 10px 0 0;
}

.titled-box-container-rank1 .titled-box-content,
.titled-box-container-rank2 .titled-box-content,
.titled-box-container-rank3 .titled-box-content {
  background-color: white;
  margin: 10px;
  margin-top: 0;
  border: 1px solid gray;
  border-radius: 0 0 10px 10px;
}

.vendor-img img {
  width: 95%;
  border-radius: 10px;
  border: 1px solid rgb(196, 196, 196);
}

.titled-box-header {
  position: relative;
  padding: 1rem 2rem 1rem 4em;
  margin-bottom: 0;
}

.titled-box-header span {
  position: absolute;
  top: -10px;
  left: 20px;
  display: inline-block;
  width: 70px;
  height: 50px;
  text-align: center;
}

.titled-box-header span i {
  position: relative;
  top: 35%;
  z-index: 1;
  width: 100%;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 900;
  color: #fff;
  text-shadow:
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    1px 1px 0 #000;
}


@media (max-width: 600px) {
  .sp-br {
    display: inline;
  }

  .availability-banner {
    padding: 20px;
    /* margin: 15px 30px 15px; */
    margin-top: 0;
  }

  .ab-icon {
    left: 14px;
    width: 26px;
    height: 26px;
    font-size: 14px;
  }

  .ab-text {
    font-size: 1.1rem;
  }

  .ab-text strong {
    font-size: 1.3rem;
  }

  .titled-box-container-rank1 .titled-box-header,
  .titled-box-container-rank2 .titled-box-header,
  .titled-box-container-rank3 .titled-box-header {
    font-size: 25px;
  }

  .titled-box-header span {
    width: 60px;
  }

  .titled-box-header span i {
    font-size: 1.3rem;
  }

  .titled-box-container-rank1 .titled-box-header span:after {
    top: 30%;
    border: 1.2em solid #ffc107;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank2 .titled-box-header span:after {
    top: 30%;
    border: 1.2em solid #aba4a4;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank3 .titled-box-header span:after {
    top: 30%;
    border: 1.2em solid #a0522d;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }
}

@media (max-width: 480px) {
  .titled-box-container-rank1 .titled-box-content,
  .titled-box-container-rank2 .titled-box-content,
  .titled-box-container-rank3 .titled-box-content {
    margin-left: 10px;
    margin-right: 10px;
  }

  .titled-box-container-rank1 .titled-box-header,
  .titled-box-container-rank2 .titled-box-header,
  .titled-box-container-rank3 .titled-box-header {
    font-size: 20px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .titled-box-header span {
    width: 50px;
  }

  .titled-box-header span i {
    font-size: 1.1rem;
  }

  .titled-box-container-rank1 .titled-box-header span:after {
    top: 30%;
    border: 1.25em solid #ffc107;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank2 .titled-box-header span:after {
    top: 30%;
    border: 1.25em solid #aba4a4;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }

  .titled-box-container-rank3 .titled-box-header span:after {
    top: 30%;
    border: 1.25em solid #a0522d;
    border-bottom-width: 15px;
    border-bottom-color: transparent;
  }
}
</style>
